import React from 'react'

export default function CommonSpinner(props) {
    const { className } = props
    return <span className={`spinner-border spinner-border-sm ${className}`}></span>
}
